import { render } from "./LearningPlanDrawer.vue?vue&type=template&id=2d485752&scoped=true"
import script from "./LearningPlanDrawer.vue?vue&type=script&lang=js"
export * from "./LearningPlanDrawer.vue?vue&type=script&lang=js"

import "./LearningPlanDrawer.vue?vue&type=style&index=0&id=2d485752&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d485752"]])

export default __exports__